// Ensures that the user doesn't just enter a single number
export const SINGLE_NUMBER_REGEX = /^-?\d*(\.?\d*)?$/;

// Identifies any instance of implicit multiplication - eg/ 3(5 + 4)
export const IMPLICIT_MULTIPLICATION_REGEX = /(\)\s*\d)|(\d\s*\()|(\)\s*\()/g;

// math-live specific, used to indicate the placeholder box
export const PLACEHOLDER_BOX = "\\placeholder{}";
